"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uniqid = _interopRequireDefault(require("uniqid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ModalContent extends _react.Component {
  state = {
    id: (0, _uniqid.default)('modal-')
  };
  handleKeyDown = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (e.keyCode === 27) {
      return component.interceptClose(e);
    }
  };
  stopPropagation = e => {
    e.stopPropagation();
  };
  preventInteraction = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  removeDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const scroll_width = window.innerWidth - document.body.clientWidth;
    let scroll_area = props['scroll-area'] ? document.querySelector(props['scroll-area']) : document.body;
    if (!scroll_area) {
      console.error('bad scroll area submited to modal :', props['scroll-area']);
    }
    scroll_area.style.paddingRight = scroll_width + 'px';
    document.querySelector('html').classList.add('u-lock-scroll');
  };
  restoreDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let scroll_area = props['scroll-area'] ? document.querySelector(props['scroll-area']) : document.body;
    if (!scroll_area) {
      console.error('bad scroll area submited to modal :', props['scroll-area']);
    }
    scroll_area.style.paddingRight = '';
    document.querySelector('html').classList.remove('u-lock-scroll');
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.removeDocumentScroll();
    document.getElementById(state.id).focus();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.restoreDocumentScroll();
    if (props.src && props.src.focus instanceof Function) {
      props.src.focus();
    }
  }
  interceptClose = (e, label) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.busy === true) return;
    if (label === 'close') {
      if (props.onValidation) {
        props.onValidation();
      }
    } else if (props.onCancel) {
      props.onCancel();
    }
    component.busy = true;
    const modal = document.getElementById(state.id);
    modal.classList.add('c-modal-cover--fade');
    modal.lastChild.classList.add('c-modal--fade');
    window.setTimeout(function () {
      component.busy = undefined;
      props.onClose(e);
    }, 330);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const footer_close_btn = props['with-footer-close'] ? /*#__PURE__*/_react.default.createElement("button", {
      role: "button",
      "aria-label": "Fermer",
      className: props['close-classes'] + ' c-modal__controls-close',
      onClick: e => component.interceptClose(e, 'close')
    }, props['close-label']) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("aside", {
      className: ['c-modal-cover'].concat(props.bemit).join(' c-modal-cover--'),
      role: props.role,
      "aria-modal": "true",
      tabIndex: "-1",
      "aria-labelledby": props['aria-label'] || props.title,
      onKeyDown: component.handleKeyDown,
      onMouseDown: component.interceptClose,
      id: state.id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-modal'].concat(props.bemit).join(' c-modal--'),
      onMouseDown: component.stopPropagation
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__header",
      id: "modal-title"
    }, props.title ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__title"
    }, props.title) : undefined), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__body"
    }, props.children), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__controls"
    }, props['action-buttons'], footer_close_btn), /*#__PURE__*/_react.default.createElement("button", {
      className: "c-modal__close",
      onClick: component.interceptClose,
      ref: props['close-ref'],
      "aria-labelledby": "modal-close"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "u-hide-visually",
      id: "modal-close"
    }, "Fermer"), /*#__PURE__*/_react.default.createElement("svg", {
      className: "c-modal__close-icon",
      viewBox: "0 0 40 40"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M 10,10 L 30,30 M 30,10 L 10,30"
    })))));
    return output;
  }
}
exports.default = ModalContent;
ModalContent.propTypes = {
  'with-footer-close': _propTypes.default.bool,
  title: _propTypes.default.string.isRequired,
  role: _propTypes.default.string,
  'aria-label': _propTypes.default.string,
  'scroll-area': _propTypes.default.string,
  'close-label': _propTypes.default.string,
  'close-classes': _propTypes.default.string,
  bemit: _propTypes.default.array,
  src: _propTypes.default.object,
  onClose: _propTypes.default.func.isRequired,
  onValidation: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  'action-buttons': _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
};
ModalContent.defaultProps = {
  'with-footer-close': true,
  'close-classes': 'c-btn c-btn--small',
  'close-label': 'Fermer',
  role: 'dialog',
  bemit: []
};
